<app-tab-bar [tabs]="tabList" [currentTab]="'home'" (updateCurrentIndex)="openTab($event)"></app-tab-bar>
<div class="site-content">
  <div class="sub-section" style="display: flex">
    <div *ngFor="let index of indices"
         [ngStyle]="{'display': index.indexLevel.id.includes('EUA') || index.indexLevel.id.includes('CCA') ? 'none' : 'block', 'width': '50%'}">
      <div class="card" style="margin-top: 0">
        <div class="card-header pointer-cursor" (click)="openIndexDetails(index.indexLevel)" style="padding: 0.5rem">
          <span class="primary-color link"> {{index.indexLevel.id}} : {{index.indexLevel.indexName}}</span>
        </div>
        <div class="card-body" style="padding: 0">
          <div class="summary-section">
            <table>
              <thead>
              <tr>
                <td>As Of Date</td>
                <td class="numeric-field">Total Return</td>
                <td class="numeric-field">Total Return % Change</td>
                <td class="numeric-field">Price Return % Change</td>
                <td class="numeric-field">Weighted Carbon Price</td>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{this.utilService.formatDate(index.indexLevel.asOf)}}</td>
                <td class="numeric-field">{{index.indexLevel.totalReturn | number: '1.2-4'}}</td>
                <td class="numeric-field">{{(index.indexLevel.totalReturnPercentage * 100) | number: '1.2-4'}}</td>
                <td class="numeric-field">{{(index.indexLevel.priceReturnPercentage * 100) | number: '1.2-4'}}</td>
                <td class="numeric-field">{{index.indexLevel.weightedCarbonPrice | number: '1.2-4'}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="chart-section" *ngIf="!index.indexLevel.id.includes('EUA') && !index.indexLevel.id.includes('CCA')">
            <app-chart-page [indexID]="index.indexLevel.id" [timePeriod]="'1Y'" [chartData]="index.chartData"></app-chart-page>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="sub-section" style="display: flex">
    <div *ngFor="let index of indices"
         [ngStyle]="{'display': index.indexLevel.id.includes('EUA') || index.indexLevel.id.includes('CCA') ? 'block' : 'none', 'width': '50%'}">
      <div class="card" style="margin-top: 10px">
        <div class="card-header pointer-cursor" (click)="openIndexDetails(index.indexLevel)" style="padding: 0.5rem">
          <span class="primary-color link"> {{index.indexLevel.id}} : {{index.indexLevel.indexName}}</span>
        </div>
        <div class="card-body" style="padding: 0">
          <div class="summary-section">
            <table>
              <thead>
              <tr>
                <td>As Of Date</td>
                <td class="numeric-field">Total Return</td>
                <td class="numeric-field">Total Return % Change</td>
                <td class="numeric-field">Price Return % Change</td>
                <td class="numeric-field"></td>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{this.utilService.formatDate(index.indexLevel.asOf)}}</td>
                <td class="numeric-field">{{index.indexLevel.totalReturn | number: '1.2-4'}}</td>
                <td class="numeric-field">{{(index.indexLevel.totalReturnPercentage * 100) | number: '1.2-4'}}</td>
                <td class="numeric-field">{{(index.indexLevel.priceReturnPercentage * 100) | number: '1.2-4'}}</td>
                <td class="numeric-field"></td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="chart-section" *ngIf="index.indexLevel.id.includes('EUA') || index.indexLevel.id.includes('CCA')">
            <app-chart-page [indexID]="index.indexLevel.id" [timePeriod]="'1Y'" [chartData]="index.chartData"></app-chart-page>
          </div>
        </div>
      </div>
    </div>
  </div>
  <lib-ihsm-alert-notification class="alert-box"
                               *ngIf="showErrorMsg" [message]="errorMessage" (close)="closeAlert()" [messageType]="alertType">
  </lib-ihsm-alert-notification>
</div>
